'use client'

import useLocalizedRouter from '@/app/hooks/useLocalizedRouter'
import useScreenSize from '@/app/hooks/useScreenSize'
import { useTranslation } from '@/app/i18n/client'
import Link from 'next/link'
import { useParams, usePathname } from 'next/navigation'
import React, { useEffect, useState } from 'react'
import CompanyDetailCard from '../../components/(MiniWebsite)/CompanyDetailCard'

const CompanyPage = ({ tab, id }: { tab: React.ReactNode; id: string }) => {
  const [activeComponent, setActiveComponent] = useState<string>('')
  const pathName = usePathname()
  const screenSize = useScreenSize()

  useEffect(() => {
    setActiveComponent(pathName.split('/').pop() || '')
  }, [pathName])

  const pushWithLocale = useLocalizedRouter()

  const handleNavigation = (component: string, path: string) => {
    setActiveComponent(component)
    pushWithLocale(path)
  }
  const params = useParams()
  const { t } = useTranslation()

  return (
    <>
      {/* Miniwebsite Navbar */}
      <div className="flex justify-center items-center relative h-[62px] mobile:top-2">
        {/* Background */}
        <span className="absolute bg-[#f5f5f5] h-[62px] w-screen top-0 z-0"></span>
        {/* Nav Items */}
        <div className="w-[1280px] mobile-width mobile:overflow-x-auto">
          <div className="flex text-[14px] select-none w-full justify-between items-center z-10">
            {/* Left Navbar */}
            <div className="flex translate-x-[330px] font-ns_semibold mobile:translate-x-0">
              <ul className="flex gap-[42px] text-sm mobile:gap-[12px] mobile:overflow-auto">
                <li
                  onClick={() =>
                    handleNavigation(
                      'profile',
                      `/fruits_and_vegetables/${id}/profile`
                    )
                  }
                  className={
                    activeComponent === 'profile'
                      ? 'cursor-pointer text-orange mobile:text-nowrap'
                      : 'cursor-pointer mobile:text-nowrap'
                  }
                >
                  <Link
                    href={`/${params?.lng}/fruits_and_vegetables/${id}/profile`}
                  >
                    {t('Profile')}
                  </Link>
                </li>
                <li
                  onClick={() =>
                    handleNavigation(
                      'product_service',
                      `/fruits_and_vegetables/${id}/product_service`
                    )
                  }
                  className={
                    activeComponent === 'product_service'
                      ? 'cursor-pointer text-orange mobile:text-nowrap'
                      : 'cursor-pointer mobile:text-nowrap'
                  }
                >
                  <Link
                    href={`/${params?.lng}/fruits_and_vegetables/${id}/product_service`}
                  >
                    {t('Product & Service')}
                  </Link>
                </li>
                <li
                  onClick={() =>
                    handleNavigation(
                      'offers',
                      `/fruits_and_vegetables/${id}/offers`
                    )
                  }
                  className={
                    activeComponent === 'offers'
                      ? 'cursor-pointer text-orange mobile:text-nowrap'
                      : 'cursor-pointer mobile:text-nowrap'
                  }
                >
                  <Link
                    href={`/${params?.lng}/fruits_and_vegetables/${id}/offers`}
                  >
                    {t('Sales Offers')}
                  </Link>
                </li>
                <li
                  onClick={() =>
                    handleNavigation(
                      'news',
                      `/fruits_and_vegetables/${id}/news`
                    )
                  }
                  className={
                    activeComponent === 'news'
                      ? 'cursor-pointer text-orange mobile:text-nowrap'
                      : 'cursor-pointer mobile:text-nowrap'
                  }
                >
                  <Link
                    href={`/${params?.lng}/fruits_and_vegetables/${id}/news`}
                  >
                    {t('News')}
                  </Link>
                </li>
                <li
                  onClick={() =>
                    handleNavigation(
                      'contact-us',
                      `/fruits_and_vegetables/${id}/contact-us`
                    )
                  }
                  className={
                    activeComponent === 'contact-us'
                      ? 'cursor-pointer text-orange mobile:text-nowrap'
                      : 'cursor-pointer mobile:text-nowrap'
                  }
                >
                  <Link
                    href={`/${params?.lng}/fruits_and_vegetables/${id}/contact-us`}
                  >
                    {t('Contact Us')}
                  </Link>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
      {/* Company Floating Card */}
      <div className="flex justify-center">
        <div className="w-[1280px] flex mobile-width mobile:flex-col">
          {(screenSize.width >= 768 ||
            pathName.split('/')[pathName.split('/').length - 1] ===
              'profile') && (
            <CompanyDetailCard
              id={id}
              companyIndustryType="fruits_and_vegetables"
            />
          )}

          <div className="ml-[27px] mt-[25px] w-full mobile:ml-[0px]">
            {tab}
          </div>
        </div>
      </div>
    </>
  )
}

export default CompanyPage
